import(/* webpackMode: "eager" */ "/vercel/path0/app/resources/page.tsx");
